import { render, staticRenderFns } from "./DocumentProperties.vue?vue&type=template&id=2d31cfde&scoped=true"
import script from "./DocumentProperties.vue?vue&type=script&lang=ts"
export * from "./DocumentProperties.vue?vue&type=script&lang=ts"
import style0 from "./DocumentProperties.vue?vue&type=style&index=0&id=2d31cfde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31cfde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d31cfde')) {
      api.createRecord('2d31cfde', component.options)
    } else {
      api.reload('2d31cfde', component.options)
    }
    module.hot.accept("./DocumentProperties.vue?vue&type=template&id=2d31cfde&scoped=true", function () {
      api.rerender('2d31cfde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentProperties.vue"
export default component.exports